/**
 * VERSIONE LIBRERIA 3
 */
var RenderMultiUpload = RenderHasmanyUpload.extend({
    dzObj : null,
    regFile : /(?:\.([^.]+))?$/,
    type : 'multi_upload',
    classData : 'multi_upload',
    classTemplate : 'multi_upload',
    init : function (key,config) {
        this._super(key,config);
    },
    _getTemplate : function () {
        var self = this;
        var tplId = self.templateId;
        if (!tplId) {
            tplId = '#'+self.prefixTemplateClass+"_multi"+self.uploadType+"_"+self.mode+"_tpl";
            if ($(tplId).length == 0)
                tplId = '#'+self.prefixTemplateClass+"_multi"+self.type+"_tpl";
            if ($(tplId).length == 0)
                throw "Template source " + '#'+self.prefixTemplateClass+"_multi"+self.uploadType+"_"+self.mode+"_tpl Not found";
        }

        return $.createDynamicContainer(tplId);
    },
    addItem : function () {
        var self = this;
        log.info("action multi upload " + self.key + " type " + self.uploadType);
        var body = $.createDynamicContainer('#' + self.prefixTemplateClass + '_multi' + self.uploadType + '_dialog_upload_tpl');
        var modelName = self.modelName;

        var params = {
            "modelName": Utility.camelCase(modelName),
            "random_id" : "tdialog" + self.uploadType,
            "langs" : self.langs

        }
        $.renderTemplate('#'+body.attr('id'), '#'+body.attr('id'), params);

        //var body = $('#' + _layout + '_dialog_upload_foto_tpl');
        //var html = $.parseTemplate(body.html(), {"modelName": self.modelName});
        var dialogId = '#upload_multi' + self.uploadType + '_dialog';
        $(dialogId + ' .modal-body').html(body.html());
        $(dialogId + ' .modal-body').css('height',300).css('over-flow','show');
        body.remove();
        var formId = 'formDrop'; // 'multi_'+ (new Date().getTime());
        $(dialogId + ' form').attr('id',formId);
        // @TODO do per scontato l'utilizzo di smarty admin

        $(dialogId + ' .btok');//x.addClass("disabled");

        $(dialogId).modal('show').ok(function () {
            //console.log(self.dzObj);//.files.getAcceptedFiles());
            //console.log(self.dzObj.files);//.files.getAcceptedFiles());
            //console.log(self.dzObj.getAcceptedFiles());
            var files = self.dzObj.getAcceptedFiles();
            for(var i in files) {
                var file = files[i];
                var formData = $(dialogId + ' form').serializeAssoc();
                formData.updated_at  = new Date();
                // TODO fare la versione per le lingue controllare le lingue
                formData.name = file.formData.filename;
                formData.filename = file.formData.filename;
                formData.mimetype= file.formData.type;
                formData.ext = file.formData.ext;//self.regFile.exec(file.name);
                formData.random= file.formData.random;
                formData.original_name = file.formData.original_name;
                self.renderNewItem(formData);
            }
            /*
             var formData = $(dialogId + ' form').serializeAssoc();
             // self.viewObj.addFotoItem(formData,key);
             formData.updated_at  = new Date();
             self.renderNewItem(formData);
             */
        }).cancel(function () {
            //alert('cancel');
        })
        $(dialogId).on('shown.bs.modal', function (e) {
            loadScript(plugin_path + 'dropzone/dropzone.js', function() {
                if (!self.dzObj) {
                    self.dzObj = new Dropzone('#' + formId, //$('#'+formId).dropzone(

                        {
                            init: function () {
                                console.log("INIT");
                                this.on("addedfile", function (file) {
                                    console.log("addedfile",$(file.previewElement).find('.dz-error-mark').length);
                                    var _this = this;
                                    $(file.previewElement).find('[data-btn_remove]').click(function () {
                                        _this.removeFile(file);
                                    });
                                    /*
                                     // Create the remove button
                                     var removeButton = Dropzone.createElement("<button class='btn btn-sm btn-default fullwidth margin-top-10'>Remove file</button>");

                                     // Capture the Dropzone instance as closure.
                                     var _this = this;

                                     // Listen to the click event
                                     removeButton.addEventListener("click", function (e) {
                                     // Make sure the button click doesn't submit the form:
                                     e.preventDefault();
                                     e.stopPropagation();

                                     // Remove the file preview.
                                     _this.removeFile(file);
                                     // If you want to the delete the file on the server as well,
                                     // you can do the AJAX request here.
                                     });

                                     // Add the button to the file preview element.
                                     file.previewElement.appendChild(removeButton);
                                     */
                                });
                                this.on('success', function (file, json) {
                                    console.log(file, json);
                                    if (json.error) {
                                        this.removeFile(file);
                                        $.errorDialog(json.msg);
                                        return;
                                    }
                                    file.formData = {};
                                    file.formData.ext = json.result.ext;
                                    file.formData.filename = json.result.filename;
                                    file.formData.mimetype = json.result.mimetype;
                                    file.formData.original_name = json.result.original_name;
                                    file.formData.random = json.result.random;
                                })
                            },
                            previewTemplate: $('#multifoto_preview_item_tpl').html()
                        });
                }
                console.log(self.dzObj);
                /*
                 Dropzone.options.formDrop = {
                 init: function() {
                 console.log("INIT");
                 this.on("addedfile", function(file) {
                 console.log("addedfile");
                 // Create the remove button
                 var removeButton = Dropzone.createElement("<button class='btn btn-sm btn-default fullwidth margin-top-10'>Remove file</button>");

                 // Capture the Dropzone instance as closure.
                 var _this = this;

                 // Listen to the click event
                 removeButton.addEventListener("click", function(e) {
                 // Make sure the button click doesn't submit the form:
                 e.preventDefault();
                 e.stopPropagation();

                 // Remove the file preview.
                 _this.removeFile(file);
                 // If you want to the delete the file on the server as well,
                 // you can do the AJAX request here.
                 });

                 // Add the button to the file preview element.
                 file.previewElement.appendChild(removeButton);
                 });
                 }
                 }
                 $('#'+formId).dropzone();
                 */
            });  // do something...
        })

    },
})